interface CompletionTiming {
  currentTime: number;
  duration: number;
  hasEnded: boolean;
  dismissed: boolean;
  showCTAOnEnd: boolean;
  cueTimeSeconds?: number;
}

export function shouldShowCompletionOverlay({
  currentTime,
  duration,
  hasEnded,
  dismissed,
  showCTAOnEnd,
  cueTimeSeconds
}: CompletionTiming): boolean {
  if (dismissed || currentTime <= 0 || duration <= 0) return false;

  if (showCTAOnEnd) {
    return hasEnded || currentTime >= duration - 0.5;
  }

  if (cueTimeSeconds !== undefined) {
    return hasEnded || currentTime >= Math.min(cueTimeSeconds, duration);
  }

  return duration > 180 && (
    hasEnded || currentTime >= duration - 180 || currentTime >= duration * 0.95
  );
}
